import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)

const state = {
    //clientBaseurl: "http://localhost:5000"
    // bindedPhone: "",
    // bindedAlipay: ""
}

export default new Vuex.Store({
    state,
    getters,
    actions,
    mutations,
})


// WEBPACK FOOTER //
// ./src/store/index.js